<div class="custom-container custom-content-login container-login min-vh-100 d-flex flex-column justify-content-start">
  <div class="d-flex flex-column align-items-center mb-3">
      <img src="assets/icons/logo-otic.svg" class="mb-5" width="140" alt="" />
      <img src="assets/icons/404.svg" alt="" class="img-fluid mt-5 mb-3" />
    </div>
</div>

